module.exports = __webpack_public_path__ + "static/media/LowStart-upCost.a8602c76.svg";